import { createRouter, createWebHistory } from "vue-router";
const Dashboard = () => import("@/views/Dashboard.vue");
const Teachers = () => import("@/views/Teachers.vue");
const Courses = () => import("@/views/Courses.vue");
const Subcourses = () => import("@/views/Subcourses.vue");
const Parents = () => import("@/views/Parents.vue");
const Kids = () => import("@/views/Kids.vue");
//const Billing = () => import("@/views/Billing.vue");
//const Profile = () => import("@/views/Profile.vue");
//const SignIn = () => import("@/views/SignIn.vue");
//const SignUp = () => import("@/views/SignUp.vue");
const LoginForm = () => import("@/views/LoginForm.vue");
const Deleted = () => import("@/views/Deleted.vue");
const Payments = () => import("@/views/Payments.vue");
const Debits = () => import("@/views/Debits.vue");
const Seasons = () => import("@/views/Seasons.vue");

//import store from "../store";

const routes = [
  {
    path: "/",
    name: "LoginForm",
    component: LoginForm,
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
  },
  /* {
    path: "/tables",
    name: "Tables",
    component: Tables,
  }, */
  {
    path: "/courses",
    name: "Courses",
    component: Courses,
    meta: {
      title: "courses",
    },
  },
  {
    path: "/subcourses",
    name: "Subcourses",
    component: Subcourses,
    meta: {
      title: "subcourses",
    },
  },
  {
    path: "/teachers",
    name: "Teachers",
    component: Teachers,
    meta: {
      title: "teachers",
    },
  },
  {
    path: "/parents",
    name: "Parents",
    component: Parents,
    meta: {
      title: "parents",
    },
  },
  {
    path: "/kids/:id?/:lastSeason?",
    name: "Kids",
    component: Kids,
    meta: {
      title: "kids",
    },
  },
  {
    path: "/kid/:kid?/:lastSeason?",
    name: "Kid",
    component: Kids,
    meta: {
      title: "kids",
    },
  },
  {
    path: "/payments",
    name: "Payments",
    component: Payments,
    meta: {
      title: "payments",
    },
  },
  {
    path: "/debits",
    name: "Debits",
    component: Debits,
    meta: { requiresRole: ["Super-Admin", "Admin"] },
  },
  {
    path: "/deleted",
    name: "Deleted",
    component: Deleted,
    meta: {
      title: "deleted",
    },
  },
  {
    path: "/seasons",
    name: "Seasons",
    component: Seasons,
    meta: { requiresRole: ["Super-Admin", "Admin"] },
  },
  /* {
    path: "/billing",
    name: "Billing",
    component: Billing,
  }, */
  /* {
    path: "/virtual-reality",
    name: "Virtual Reality",
    component: VirtualReality,
  }, */
  /* {
    path: "/profile",
    name: "Profile",
    component: Profile,
  }, */
  /* {
    path: "/rtl-page",
    name: "Rtl",
    component: Rtl,
  }, */
  /* {
    path: "/sign-in",
    name: "Sign In",
    component: SignIn,
  }, */
  /* {
    path: "/sign-up",
    name: "Sign Up",
    component: SignUp,
  }, */
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

router.beforeEach((to, _from, next) => {
  const isAuthenticated = !!localStorage.getItem("token");
  const userRole = localStorage.getItem("userRole");

  if (to.matched.some((record) => record.meta.requiresRole)) {
    if (to.meta.requiresRole.includes(userRole)) {
      next();
    } else {
      next({ path: "/" });
    }
  } else if (to.name !== "LoginForm" && !isAuthenticated) {
    next({ name: "LoginForm" });
  } else {
    next();
  }
});

export default router;
